// #95 LevelRule (DC-36; replaces alt's rule2, whose text is not ported): one banner whose sentence, colour and
// consequence depend on the requisition's level band.
//   Sr Director and below: the warn banner "Any No Hire or two ratings of 2 or below creates a concern flag", turning
//   the flag banner with the *Concern flag* pill when the ratings entered so far meet it.
//   VP+: the red form (--red-text on --t-red) "Any No Hire or any rating of 2 or below is No Hire"; when met it adds
//   the *No Hire* pill — the caller locks the recommendation to No Hire (RecoTiles with Hire blocked).
// The band's name leads the banner. It flips live: the banner is a polite status region.

import { cx } from "../lib/cx";
import { LEVEL_RULE_LABELS, RECOMMENDATION_LABELS } from "../labels";
import { Banner } from "../core/Banner";
import { Pill } from "../core/Pill";

export type LevelRuleBand = "sr_director_and_below" | "vp_plus";

export interface LevelRuleProps {
  level: LevelRuleBand;
  /** The ratings and recommendation entered so far meet the rule. */
  met: boolean;
  className?: string | undefined;
}

export function LevelRule({ level, met, className }: LevelRuleProps) {
  const vp = level === "vp_plus";
  const band = vp ? LEVEL_RULE_LABELS.vpPlus : LEVEL_RULE_LABELS.srDirectorAndBelow;
  const sentence = vp ? LEVEL_RULE_LABELS.vpRule : LEVEL_RULE_LABELS.srDirectorRule;
  const consequence = met
    ? <Pill tone={vp ? "red" : "flag"}>{vp ? RECOMMENDATION_LABELS.noHire : LEVEL_RULE_LABELS.concernFlag}</Pill>
    : null;
  return (
    <div role="status" className={cx("mc-lrule", className)}>
      <Banner
        tone={vp ? "red" : met ? "flag" : "warn"}
        icon={met ? "flag" : "alert"}
        className={cx(vp && "mc-lrule-vp", met && "mc-lrule-met")}
      >
        <b className="mc-lrule-band">{band}</b> {sentence}{consequence ? <> {consequence}</> : null}
      </Banner>
    </div>
  );
}
